import axios from './axios';

/**
 * Graph Visualization API service
 */
export const graphApi = {
  /**
   * Get graph data for a file's requirements
   * @param {number} fileId
   * @param {object} params - { focus_requirement_id, depth, relationship_types }
   */
  getGraphData: async (fileId, params = {}) => {
    const response = await axios.get(`files/${fileId}/graph-data/`, { params });
    return response.data;
  },

  /**
   * Expand a node to get its neighbors
   * @param {number} requirementId - DB id of the requirement
   * @param {object} params - { depth, relationship_types }
   */
  expandNode: async (requirementId, params = {}) => {
    const response = await axios.get(`requirements/${requirementId}/graph-expand/`, { params });
    return response.data;
  },
};
